function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var deepmerge = require('deepmerge');

import { theme as defaultTheme } from '../theme/theme';
import { createTextStyles, createColorStyles, createMediaQueries, createPalette } from '.';
/**
 * Adds aliases to an array of keys
 *
 * @param {Array} arr The array to add aliases to
 */

var addAliases = function addAliases(arr) {
  arr.forEach(function (val, key) {
    arr[['sm', 'md', 'lg', 'xl', 'xxl'][key]] = val;
  });
  return arr;
};
/**
 * Create the theme
 *
 * @param {Object}  theme             The theme to merge against the default
 * @param {Object}  customBreakpoints Custom breakpoints for the theme
 *
 * @returns {Object} The generated theme
 */


var createTheme = function createTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customBreakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var mergedTheme = deepmerge(defaultTheme, theme);
  var mediaQueries = customBreakpoints ? createMediaQueries(customBreakpoints) : mergedTheme.mediaQueries;
  return _objectSpread(_objectSpread({}, mergedTheme), {}, {
    contrastRatio: mergedTheme.contrastRatio || 2.6,
    breakpoints: addAliases(customBreakpoints || mergedTheme.breakpoints),
    mediaQueries: addAliases(mediaQueries),
    palette: createPalette(mergedTheme),
    colorStyles: createColorStyles(mergedTheme),
    textStyles: createTextStyles(mergedTheme)
  });
};

export { createTheme };